module.exports = __webpack_public_path__ + "static/media/logo-python.7759b8cd.svg";